import script from "./GlobalSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSection.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSection.vue?vue&type=style&index=0&id=c1f1acc8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f1acc8"]])

export default __exports__